/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Scope_Point_3Inputs */

const en_svc_agents_scope_point_3 = /** @type {(inputs: Svc_Agents_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM updates and data clean-up`)
};

const lv_svc_agents_scope_point_3 = /** @type {(inputs: Svc_Agents_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM atjaunināšana un datu sakārtošana`)
};

/**
* | output |
* | --- |
* | "CRM updates and data clean-up" |
*
* @param {Svc_Agents_Scope_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_scope_point_3 = /** @type {((inputs?: Svc_Agents_Scope_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Scope_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_scope_point_3(inputs)
	return en_svc_agents_scope_point_3(inputs)
});